module.exports = __webpack_public_path__ + "img/ShueiNanDongBanner.be09e3b6.png";